<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="4" />
    <div class="breadcrumb-container">
      <router-link to="/guias">Guías de Inicio Rápido</router-link>
    </div>
    <div class="main-content">
      <!-- Renderiza dinámicamente el componente seleccionado -->
      <component :is="defaultComponent" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: "MainLayout",
  components: {
    Layout,
    Footer
  },
  props: {
    defaultComponent: Object
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  }
};
</script>

<style scoped>
.main-content {
  padding: 20px;
  min-height: 300px;
}
</style>